import { put, select } from "redux-saga/effects";

import { apiFetch } from "common/utilities";
import {
  deleteTopicContentFulfilled,
  deleteTopicContentRejected,
  fetchTopicContentList,
} from "domains/customContentAndSources/actions";
import type { DeleteTopicContentAction } from "domains/customContentAndSources/actionTypes";
import { deactivateModal, pushModalScreen } from "domains/modal/actions";
import { getActiveModalId } from "domains/modal/selectors";

export function* deleteTopicContentSaga({ payload }: DeleteTopicContentAction) {
  try {
    yield apiFetch(`topic/${payload.topicId}/attachment/${payload.id}`, {
      method: "DELETE",
    });
    const { topicId } = payload;
    yield put(fetchTopicContentList({ topicId }));
    yield put(deleteTopicContentFulfilled(payload));
    const currentModal: ReturnType<typeof getActiveModalId> = yield select(getActiveModalId);
    if (currentModal === "AddCustomContent") {
      yield put(deactivateModal());
    }
  } catch {
    yield put(deleteTopicContentRejected({ logoutOnAuthError: true, ...payload }));
    yield put(pushModalScreen({ id: "Error" }));
  }
}
